module.exports = __webpack_public_path__ + "img/c3.863456f9.png";